import React from 'react';

const WhyUs = () => {
  return (
    <section className="py-20 overflow-hidden" dir="rtl">
      {/* Background Gradient Modern */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-800 opacity-90"></div>
        <div className="absolute inset-0 bg-black opacity-30"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
            چرا <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-pink-400">ما</span> بهترین انتخاب هستیم؟
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            مقایسه‌ای شفاف با بانک‌ها، صندوق‌های سرمایه‌گذاری و روش‌های سنتی — جایی که آزادی، هوش و کنترل شخصی حرف اول رو می‌زنه.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* کارت ۱: پول در دست خودتون */}
          <div className="group relative bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:border-cyan-400 transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl hover:shadow-cyan-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition"></div>
            <div className="relative z-10">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-4xl">💰</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                پول همیشه در دست خودتون
              </h3>
              <div className="space-y-4 text-gray-200">
                <p className="flex items-start gap-3">
                  <span className="text-green-400 text-xl">✓</span>
                  <span><strong>ما:</strong> سرمایه کاملاً در حساب شخصی شماست — کنترل ۱۰۰٪ و دسترسی آنی.</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="text-red-400 text-xl">✗</span>
                  <span><strong>بانک‌ها و صندوق‌ها:</strong> پول به حساب آن‌ها منتقل می‌شه، با محدودیت برداشت و هزینه‌های پنهان.</span>
                </p>
              </div>
            </div>
          </div>

          {/* کارت ۲: مشاوره شخصی */}
          <div className="group relative bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:border-purple-400 transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl hover:shadow-purple-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition"></div>
            <div className="relative z-10">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-purple-400 to-pink-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-4xl">🧑‍💼</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                مشاوره کاملاً شخصی‌سازی‌شده
              </h3>
              <div className="space-y-4 text-gray-200">
                <p className="flex items-start gap-3">
                  <span className="text-green-400 text-xl">✓</span>
                  <span><strong>ما:</strong> هوش مصنوعی + مشاور اختصاصی بر اساس اهداف، ریسک و وضعیت مالی شما.</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="text-red-400 text-xl">✗</span>
                  <span><strong>بانک‌ها و صندوق‌ها:</strong> مشاوره عمومی و فروش‌محور بدون توجه واقعی به نیازهای شما.</span>
                </p>
              </div>
            </div>
          </div>

          {/* کارت ۳: مدیریت هوشمند */}
          <div className="group relative bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:border-pink-400 transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl hover:shadow-pink-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition"></div>
            <div className="relative z-10">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-pink-400 to-red-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-4xl">🤖</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                مدیریت هوشمند با هوش مصنوعی
              </h3>
              <div className="space-y-4 text-gray-200">
                <p className="flex items-start gap-3">
                  <span className="text-green-400 text-xl">✓</span>
                  <span><strong>ما:</strong> تحلیل real-time بازار، پیشنهادهای هوشمند و ابزارهای پیشرفته داشبورد.</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="text-red-400 text-xl">✗</span>
                  <span><strong>بانک‌ها و صندوق‌ها:</strong> مدیریت سنتی، هزینه بالا و بازدهی متوسط بدون نوآوری دیجیتال.</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-20">
          <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-6">
            آینده سرمایه‌گذاری همین‌جاست
          </h3>
          <p className="text-xl text-gray-200 max-w-4xl mx-auto mb-10">
            آزادی کامل + مشاوره شخصی + هوش مصنوعی پیشرفته = بازدهی بالاتر و آرامش خاطر بیشتر
          </p>
          <button className="px-10 py-5 text-xl font-bold text-indigo-900 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-full hover:shadow-2xl hover:shadow-cyan-400/50 transition transform hover:scale-105">
            همین حالا شروع کنید 🚀
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;